import React from 'react';
import Productlist from '../PRODUCTSLIST/Productlist';

const Home = () => (
  <div className="hmpg-container">
    <Productlist />
  </div>
);

export default Home;
